<template>
    <section>
        <Sidebar />
        <Content class="create-endpoint-page">
            <Plans />
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getJWTContent, getUserPlan} from "../logic/global"
import constants from '../constants'
import Plans from '../components/Plans'


export default {
    name: 'Pricing',
    components: {Sidebar, Content, Plans},
    data() {
        return {
            user_plan: null,
            plan_limitations: null,
        }
    },
    methods: {
        goToNextStep: function(){
            this.endpoint["user"] = getJWTContent()["id"]
            createEndpoint(this.endpoint).then(response => {
                this.$router.push({name: "home"})
            }).catch(error => {

            });
        }
    },
    mounted: function(){
        getUserPlan().then(response => {
            this.user_plan = response.data
            this.plan_limitations = constants.PLANS_LIMITATIONS[this.user_plan.plan]
        })
    }
}
</script>

<style scoped>
  h1{margin-bottom: 24px;}
  .checkbox-field{margin-right: 35px;}
  #create-endpoint-page >>> .b-slider.is-large .b-slider-tick-label{margin-top: 12px;}
  .slider-field-interval >>> label{margin-left: -15px; margin-top: 30px;}
  .slider-field-interval >>> .b-slider-tick-label{margin-top: 13px !important; width: 60px; text-align: center;}
</style>